<template>
  <div class="form-group" v-bind:class="{ error: error[0] }">
    <label>Выберите квартиру</label>
    <el-select
      placeholder="Выберите квартиру"
      filterable
      v-model="localValue"
      :disabled="disabled"
      >
      <el-option
        v-for="option in options"
        :key="option.value"
        :label="option.label"
        :value="option.value">
      </el-option>
    </el-select>
    <div class="error">{{ error[0] }}</div>
  </div>
</template>

<script>
import { getList } from '@/services/__common.service'

export default {
  name: 'apartment-field',
  props: {
    value: [String, Number],
    error: Array,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      localValue: '',
      options: []
    }
  },
  mounted () {
    this.localValue = this.value

    this.getList('/apartments', 'number', 'asc').then((response) => {
      this.options = response.data['results'].map(apartment => {
        return { value: apartment.id, label: apartment.full_name }
      })
    })
  },
  watch: {
    value: function (val) {
      this.localValue = val
    },
    localValue: function (val) {
      this.updateValue(val)
    }
  },
  methods: {
    getList: getList,
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>


// WEBPACK FOOTER //
// Apartment.vue?d6d89756